import { isPlatformBrowser, NgClass } from '@angular/common';
import { Component, HostBinding, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../components/footer/footer.component';
import { HeaderComponent } from '../components/header/header.component';

@Component({
  templateUrl: './general-shell.component.html',
  styleUrls: ['./general-shell.component.scss'],
  standalone: true,
  imports: [RouterOutlet, NgClass, FooterComponent, HeaderComponent],
})
export class GeneralShellComponent implements OnInit {
  @HostBinding('class') private fullHeight = 'flex flex-col min-h-[100vh] kk';

  isScrolled = false;

  constructor(private renderer: Renderer2, @Inject(PLATFORM_ID) private platformId: object) {}

  ngOnInit(): void {
    // For sticky header
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.listen('window', 'scroll', () => {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;
        this.isScrolled = scrollPosition > 50;
      });
    }
  }
}
